import { Component, OnInit } from '@angular/core';
import { BusinessService } from '../../../services/business.service';

@Component({
  selector: 'app-header-generic',
  templateUrl: './header-generic.component.html',
  styleUrls: ['./header-generic.component.scss'],
})
export class HeaderGenericComponent implements OnInit {

  constructor(private businessService: BusinessService) { }
    ngOnInit() {
  }

  navigateHapvidaHome() {
    var url = this.businessService.getBusinessUrl();
    if (url) {
      window.open(url, '_self');
    }
    return;
  }

}
